import { useCallback } from "react";

import SVGSprite from "@/components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";

import BookSlotModal from "../../../BookSlotModal";

import { classNameGenerator } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";
import * as actions from "@/redux/BootCampReducer";

import styles from "./TrialSection.module.scss";

interface TrialSectionProps {}

const TrialSection: React.FC<TrialSectionProps> = () => {
  const dispatch = useAppDispatch();

  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { trialData, trialSection } = data;

  const { currencySymbol, price } = trialData;
  const { prefix, title } = trialSection;

  const formTitle = "Submit your details";

  const setShowBookTrialClassModal = useCallback(
    (value: any) => {
      dispatch(actions.setShowBookTrialClassModal(value));
    },
    [dispatch]
  );

  return (
    <section className={cls("trialSection")}>
      <div
        className={cls("container")}
        onClick={() => setShowBookTrialClassModal({ packageData: trialData })}
      >
        <div className={cls("leftSection")}>
          <Typography variant="paragraph1" className={cls("prefix")}>
            {prefix}
          </Typography>
          <div className={cls("titleWrapper")}>
            {currencySymbol && price!==null && <Typography
              variant="heading3"
              className={cls("title")}
              dangerouslySetInnerHTML={{
                __html: `${title} ${currencySymbol}&nbsp;${price}`,
              }}
            />}
          </div>
        </div>
        <div className={cls("rightSection")}>
          <SVGSprite icon="icon-header-chevron-right" className={cls("icon")} />
        </div>
      </div>
      <BookSlotModal title={formTitle} />
    </section>
  );
};

export default TrialSection;
